import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import Circular from "../Circular/Circular";
import Button from "components/CustomButtons/Button.js";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Input from "@material-ui/core/Input";
import InputLabel from "@material-ui/core/InputLabel";
import { createSlot } from "../../services/slots/slots";
import { lockerColumns } from "variables/lockerColumns";

const useStyles = (theme) => ({
  iconView: {
    color: "gray !important",
  },
  root: {
    "& .MuiFormControl-root": {
      margin: theme.spacing(1),
      width: 200,
    },
  },
  dialog: {
    "& .MuiPaper-root": {
      margin: theme.spacing(1),
      width: 250,
      height: 200,
    },
  },
  green: {
    "& label.Mui-focused": {
      color: "green",
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "green",
    },
  },
  red: {
    "& label.Mui-focused": {
      color: "red",
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "red",
    },
  },
});

class NewColumn extends Component {
  constructor(props) {
    super(props);
    this.createSlot = this.createSlot.bind(this);
    this.handleClickOpen = this.handleClickOpen.bind(this);
    this.handleCreate = this.handleCreate.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleChange = this.handleChange.bind(this);

    this.state = {
      sizes: [
        {
          value: "small",
          label: "Pequeno",
          cl: "P"
        },
        {
          value: "medium",
          label: "Médio",
          cl: "M"
        },
        {
          value: "large",
          label: "Grande",
          cl: "G"
        },
        {
          value: "extra-large",
          label: "Extra Grande",
          cl: "XG"
        },
      ],
      categories: [
        {
          value: false,
          label: "sem restrição",
        },
        {
          value: true,
          label: "deficiente físico",
        },
        {
          value: "control",
          label: "painel de controle",
        },
      ],
      size: null,
      columnModel: null,
      slot: "",
      label: "",
      waiting: false,
      error: false,
      category: "",
      deviceCondition: null,
      pne: false,
    };
  }

  createSlot = (lockerId, data) => {
    new Promise((resolve, reject) => {
      createSlot(lockerId, data, (dataR) => {
        // this.setState({ waiting: false });
        // this.props.onChange(false);
        dataR
          ? this.props.setNotification(
            "Nova Porta criada com sucesso!",
            "success"
          )
          : this.props.setNotification("Falha ao criar Nova Porta!", "danger");
        resolve(dataR);
      });
    })
  };

  handleChange = (event) => {
    let e = event.target.id ? event.target.id : event.target.name;
    switch (e) {
      case "slot":
        this.setState({ slot: event.target.value });
        break;
      case "label":
        this.setState({ label: event.target.value });
        break;
      default:
        this.setState({ columnModel: event.target.value });
        break;
    }
  };

  handleClickOpen = () => {
    this.props.onChange(true);
  };

  handleCreate = async () => {
    let { columnModel, slot, label, deviceCondition, pne } = this.state;
    let { lockerId } = this.props;

    if (lockerId && columnModel && slot && label) {
      this.setState({ waiting: true, error: false });

      for (let index = 0; index < columnModel.length; index++) {
        const element = columnModel[index];
        const sizeFind = this.state.sizes.find((el) => el.cl === element);
        const size = sizeFind.value;
        const slotInt = parseInt(slot * 1 + index);
        const slotString = (slotInt < 10) ? `0${slotInt}` : `${slotInt}`;
        const labelString = `${label}${index + 1}`;

        deviceCondition = deviceCondition ? deviceCondition : 'Created';
        let data = {
          name: slotString,
          status: 'available',
          size,
          label: labelString,
          deviceCondition,
          pne
        };
        console.log(JSON.stringify(data));

        await this.createSlot(lockerId, data);

      }

      this.setState({ waiting: false, error: false });
      this.props.onChange(false);

    }


    // if (lockerId && size && slot) {
    //   this.setState({ waiting: true, error: false });
    //   deviceCondition = deviceCondition ? deviceCondition : 'Created';
    //   let data = {
    //     name: slot, 
    //     status: 'available',
    //     size, 
    //     label,
    //     deviceCondition,
    //     pne
    //   };
    //   this.createSlot(lockerId, data);
    // } else {
    //   this.setState({ error: true });
    // }
  };

  handleClose = () => {
    this.props.onChange(false);
  };

  getStringFromArray = (array) => {
    let valReturn = "";

    for (let index = 0; index < array.length; index++) {
      const element = array[index];
      valReturn = `${valReturn}${(index > 0) ? " " : ""}${element}`;
    }

    return valReturn;

  }

  render() {
    const { classes } = this.props;

    return (
      <div>
        <Dialog
          className={this.state.waiting ? classes.dialog : null}
          open={this.props.open}
          onClose={this.handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            {this.state.waiting ? "Criando Coluna" : "Criar Nova Coluna"}
          </DialogTitle>
          <DialogContent>
            {this.state.waiting ? (
              <div>
                <Circular />
              </div>
            ) : (
              <form className={classes.root} noValidate autoComplete="off">
                <div className="align-fields">
                  <FormControl
                    className={
                      this.state.error && !this.state.slot
                        ? classes.red
                        : classes.green
                    }
                  >
                    <InputLabel htmlFor="slot">Slot Inicial da Coluna</InputLabel>
                    <Input
                      error={
                        this.state.error && !this.state.slot ? true : false
                      }
                      value={this.state.slot}
                      onChange={this.handleChange}
                      placeholder="01"
                      id="slot"
                    />
                  </FormControl>
                  <FormControl
                    className={
                      this.state.error && !this.state.label
                        ? classes.red
                        : classes.green
                    }
                  >
                    <InputLabel htmlFor="slot">Radical da Coluna</InputLabel>
                    <Input
                      error={
                        this.state.error && !this.state.label ? true : false
                      }
                      value={this.state.label}
                      onChange={this.handleChange}
                      id="label"
                    />
                  </FormControl>
                </div>
                <div>
                  <TextField
                    className={
                      this.state.error && !this.state.columnModel
                        ? classes.red
                        : classes.green
                    }
                    // id="outlined-size-input"
                    error={this.state.error && !this.state.columnModel ? true : false}
                    select
                    label="Modelo da Coluna"
                    value={this.state.columnModel}
                    onChange={this.handleChange}
                    fullWidth
                  >
                    {lockerColumns.map((option) => (
                      <MenuItem key={option.label} value={option.column}>
                        {`${option.label} (${this.getStringFromArray(option.column)})`}
                      </MenuItem>
                    ))}
                  </TextField>

                </div>
              </form>
            )}
          </DialogContent>
          <DialogActions>
            {this.state.waiting ? null : (
              <div>
                <Button onClick={this.handleClose} color="default">
                  Cancelar
                </Button>
                <Button onClick={this.handleCreate} color="primary" autoFocus>
                  Criar
                </Button>
              </div>
            )}
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}
export default withStyles(useStyles)(NewColumn);
